/*
 * @Description: 
 * @Author: ywj
 * @Date: 2025-04-14 09:25:33
 * @LastEditTime: 2025-04-14 14:32:22
 * @LastEditors: ywj@originqc.com
 */
import request from '@/utils/request';

// 优惠券发票列表
export const couponList = (data:any) =>
  request({
    url: `attachCenter/couponHistory/list.json`,
    method: 'post',
    data,
  });

  // 领取优惠券
  export const getCoupons = (data:any) =>
  request({
    url: `attachCenter/couponHistory/receive.json`,
    method: 'post',
    data,
  });

   // 兑换优惠券
   export const exchangeCode = (data:any) =>
   request({
     url: `attachCenter/couponHistory/exchangeCode.json`,
     method: 'post',
     data,
   });

    // 兑换优惠券
    export const deleteById = (data:any) =>
    request({
      url: `attachCenter/couponHistory/deleteById.json/${data?.id}`,
      method: 'post',
     data,
    });